import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ConfirmationRequest {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  tone: 'danger' | 'primary';
}

export type ConfirmationOptions = Partial<Omit<ConfirmationRequest, 'message'>> & Pick<ConfirmationRequest, 'message'>;

@Injectable({ providedIn: 'root' })
export class ConfirmationService {
  private readonly requestSubject = new BehaviorSubject<ConfirmationRequest | null>(null);
  private pendingResolution?: (confirmed: boolean) => void;

  readonly request$ = this.requestSubject.asObservable();

  confirm(options: ConfirmationOptions): Promise<boolean> {
    this.resolve(false);
    this.requestSubject.next({
      title: options.title || 'Confirm action',
      message: options.message,
      confirmLabel: options.confirmLabel || 'Confirm',
      cancelLabel: options.cancelLabel || 'Cancel',
      tone: options.tone || 'primary'
    });

    return new Promise<boolean>(resolve => {
      this.pendingResolution = resolve;
    });
  }

  accept(): void {
    this.resolve(true);
  }

  cancel(): void {
    this.resolve(false);
  }

  private resolve(confirmed: boolean): void {
    const pending = this.pendingResolution;
    this.pendingResolution = undefined;
    this.requestSubject.next(null);
    pending?.(confirmed);
  }
}
